import { createAction } from 'redux-actions'
import {
  UPDATE_HREFS,
  FETCH_CARDS,
  FETCH_CARD,
  FETCH_CARD_SUCCESS,
  FETCH_CARD_FAILURE,
} from './constants'

export const updateHrefs = createAction(UPDATE_HREFS)
export const fetchCards = createAction(FETCH_CARDS)
export const fetchCard = createAction(FETCH_CARD)
export const fetchCardSuccess = createAction(FETCH_CARD_SUCCESS)
export const fetchCardFailure = createAction(FETCH_CARD_FAILURE)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/cards/actions.js